import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import { Grid } from "@mui/material";
import Box from "@mui/material/Box";
import { actionRequiredData } from "../../Services/ActionRequired.service";
import { useSelector } from "react-redux";
import useToaster from "../../customHook/useToaster";

export default function ActionRequiredComponent() {
  const [actionRequiredDataState, setActionRequiredDataState] = useState([]);
  const [activeTab, setactiveTab] = useState("current");
  const { activeTourStep } = useSelector((state) => state.appTourSlice);
  const { showToast } = useToaster();
  const isTourActive =
    activeTourStep === 10
      ? {
          background: "white",
          boxShadow: "0px 2px 10px 0px #FFFFFFB2",
          borderRadius: "20px",
          border: "1px solid #9F9F9F",
          padding: "8px",
        }
      : {};

  const actionFilterTabs = ["current", "past"];

  useEffect(() => {
    actionRequiredData(activeTab)
      .then((data) => {
        let {
          totalOpenCases = 0,
          totalFraudCases = 0,
          totalNonFraudCases = 0,
        } = data?.data;
        setActionRequiredDataState([
          totalOpenCases,
          totalFraudCases,
          totalNonFraudCases,
        ]);
      })
      .catch((error) => {
        showToast(
          error?.response?.data?.message ||
            "Something went wrong while loading cases by status.",
          "error",
          true
        );
      });
  }, [activeTab]);

  const actionRequiredTabsButtonHandler = (value) => {
    setactiveTab(value);
  };

  return (
    <Box
      style={{ position: "relative", height: "100%", ...isTourActive }}
      id="dash-action"
    >
      <div
        style={{
          position: "relative",
          height: "100%",
          paddingLeft: "1.5rem",
          paddingTop: "0.5rem",
          border: "0.1rem solid #F2F2F2",
          borderRadius: "0.67rem",
        }}
      >
        <Grid>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "0.3rem",
              paddingRight: "0.8rem",
            }}
          >
            <Box sx={{ fontSize: "1.7rem", color: "#242424", fontWeight: 500 }}>
              Cases by Status
            </Box>
            <Box>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                  marginLeft: "0rem",
                  textAlign: "center",
                }}
              >
                {actionFilterTabs.map((tabName, id) => (
                  <div key={id}>
                    <button
                      id={tabName}
                      style={{
                        padding: "0.5rem 1.6rem",
                        fontSize: "1.1rem",
                        borderRadius: "4px",
                        width: "100%",
                        cursor: "pointer",
                        outline: "none",
                        color: activeTab === tabName ? "white" : "#B1B3B5",
                        border: `1px solid ${
                          activeTab === tabName ? "#e8505b" : "#B1B3B5"
                        }`,
                        background: activeTab === tabName ? "#e8505b" : "none",
                      }}
                      onClick={() => actionRequiredTabsButtonHandler(tabName)}
                    >
                      {tabName}
                    </button>
                  </div>
                ))}
              </div>
            </Box>
          </Box>

          <Grid sx={{ display: "flex", justifyContent: "center", mt: "3rem" }}>
            <Chart
              width="100%"
              height="auto"
              type="donut"
              series={actionRequiredDataState}
              options={{
                labels: ["Open", "Fraud", "Not Fraud"],
                plotOptions: {
                  pie: {
                    donut: {
                      labels: {
                        name: {
                          show: true,
                          formatter: () => {
                            return "Total Cases";
                          },
                        },
                        show: true,
                        total: {
                          show: true,
                          showAlways: true,
                        },
                        value: {
                          show: true,
                          showAlways: true,
                          fontSize: 24,
                          fontWeight: 500,
                          color: "#3A3A3A",
                        },
                      },
                    },
                  },
                },
                dataLabels: {
                  style: {
                    fontSize: "1rem",
                  },
                },
                legend: {
                  show: true,
                  showForSingleSeries: false,
                  showForNullSeries: true,
                  showForZeroSeries: true,
                  position: "bottom",
                  horizontalAlign: "center",
                  floating: false,
                  fontSize: "12px",
                  fontFamily: "Inter",
                  fontWeight: 500,
                  formatter: undefined,
                  inverseOrder: false,
                  width: "100%",
                  height: undefined,
                  tooltipHoverFormatter: undefined,
                  customLegendItems: [],
                  offsetX: 0,
                  offsetY: 0,
                  padding: 0,
                  labels: {
                    colors: undefined,
                    useSeriesColors: false,
                  },
                  markers: {
                    width: 12,
                    height: 12,
                    strokeWidth: 0,
                    strokeColor: "#fff",
                    fillColors: undefined,
                    radius: 0,
                    customHTML: undefined,
                    onClick: undefined,
                    offsetX: 0,
                    offsetY: 0,
                  },
                },
              }}
            />
          </Grid>
        </Grid>
      </div>
    </Box>
  );
}
